import React, { Dispatch, SetStateAction, useCallback } from 'react'
import SelfRegCouponMainPageView from 'src/pages/SelfRegCouponPage/SelfRegCouponMainPage/view'
import {
  selfRegisterCouponListQueryOption,
  useInfiniteScrollQuery,
} from 'src/hooks/react-query/useCustomInfiniteQuery.hook'
import {
  ResponseDataType,
  SelfRegisterCouponDeleteSpace,
  SelfRegisterCouponListSpace,
} from 'src/types/api'
import usePageNav from 'src/hooks/usePageNav.hook'
import { useModal } from 'src/provider/ModalContextProvider'
import {
  selfRegisterCouponDeleteQueryOption,
  useCustomMutation,
} from 'src/hooks/react-query/useCustomMutation.hook'
import { ERRCODE_SUCCESS } from 'src/service/constant/errcodes'
import RenderIf from 'src/components/common/RenderIf'
import { Loading } from 'src/components/common/Loading'
export interface SelfRegCouponMainPageProps {
  selfRegisterCouponListData: SelfRegisterCouponListSpace.SelfRegisterCouponItemsType[]
  setTarget: Dispatch<SetStateAction<HTMLDivElement | null | undefined>>
  selfRegisterCouponNoMore: boolean
  selfRegisterUpdatePageNav: (idx: number) => void
  selfRegisterCouponDeleteHandler: (idx: number) => void
  selfRegisterCreatePageNav: () => void
}

const SelfRegCouponMainPage = () => {
  const { selfRegisterUpdatePageNav, selfRegisterCreatePageNav } = usePageNav()
  const { openModal } = useModal()

  const {
    data: selfRegisterCouponListQueryData,
    isPending: isSelfRegisterCouponListPending,
    setTarget,
    refetch: selfRegisterCouponListRefetch,
  } = useInfiniteScrollQuery<
    SelfRegisterCouponListSpace.Request,
    SelfRegisterCouponListSpace.Response
  >(selfRegisterCouponListQueryOption())

  const { mutateAsync: selfCouponDeleteMutate, isPending: isSelfCouponDeletePending } =
    useCustomMutation<
      SelfRegisterCouponDeleteSpace.Request,
      SelfRegisterCouponDeleteSpace.Response
    >(selfRegisterCouponDeleteQueryOption())

  const selfRegisterCouponListProcessData = useCallback(() => {
    let result: SelfRegisterCouponListSpace.SelfRegisterCouponItemsType[] | any[] = []
    selfRegisterCouponListQueryData?.pages?.map(
      (element: ResponseDataType<SelfRegisterCouponListSpace.Response>) => {
        !!element?.Body?.CouponSelf && result.push(...element?.Body?.CouponSelf)
      },
    )
    return result
  }, [selfRegisterCouponListQueryData])

  const selfRegisterCouponNoMore =
    selfRegisterCouponListQueryData?.pages?.at(-1)?.Body?.CouponSelf?.length === 0

  const selfCouponDeleteSubmit = (idx: number) => {
    selfCouponDeleteMutate({ Idx: idx }).then(({ Header }) => {
      Header.ErrCode === ERRCODE_SUCCESS && selfRegisterCouponListRefetch?.()
    })
  }

  const selfRegisterCouponDeleteHandler = (idx: number) => {
    openModal({
      contents: { d: '쿠폰을 삭제하시겠습니까?' },
      button: {
        submit: { t: '삭제', f: () => selfCouponDeleteSubmit(idx) },
        cancel: { t: '취소' },
      },
    })
  }

  const props: SelfRegCouponMainPageProps = {
    setTarget,
    selfRegisterCouponListData: selfRegisterCouponListProcessData(),
    selfRegisterUpdatePageNav,
    selfRegisterCouponDeleteHandler,
    selfRegisterCreatePageNav,
    selfRegisterCouponNoMore,
  }
  return (
    <React.Fragment>
      <RenderIf when={isSelfRegisterCouponListPending || isSelfCouponDeletePending}>
        <Loading.Default />
      </RenderIf>
      <SelfRegCouponMainPageView {...props} />
    </React.Fragment>
  )
}
export default SelfRegCouponMainPage
